import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Spinner from '../../../../../components/Spinner/Spinner';
import { useAppSelector } from '../../../../../reduxService/hooks';
import { selectProjectInfo } from '../../../../store/projectInfo/projectInfoSlice';
import { MenuItem } from '@mui/material';

interface IPdf {
    pdfBlob?: Blob;
    pdfUrl?: string;
    onClick: any;
    className?: string;
    imgs: string[];
    setImgs: React.Dispatch<React.SetStateAction<string[]>>;
}

export const WRAPPER_DIV_NAME = 'div-for-pdf-img-wrapper';
export const CANVAS_INITIAL_ID = 'the-canvas';

export const Pdf = (prop: IPdf) => {
    const { pdfUrl, imgs, setImgs } = prop;
    const { t } = useTranslation();

    const [loading, setLoading] = React.useState<boolean>(true);
    const projectInfo = useAppSelector(selectProjectInfo);

    const appendCanvasAfterNumPages = React.useCallback(async (pages: number) => {
        return new Promise(resolve =>
            setTimeout(() => {
                const canvasWrapper = document.getElementById(WRAPPER_DIV_NAME);
                let canvas;
                for (let i = 0; i < pages; i++) {
                    canvas = document.createElement('canvas');
                    canvas.setAttribute('id', CANVAS_INITIAL_ID + i);
                    canvas.style.zIndex = '-1';
                    canvas.style.height = '100vh';
                    if (!!canvasWrapper) {
                        canvasWrapper.appendChild(canvas);
                    }
                }
                resolve(true);
            }, 2000),
        );
    }, []);

    const convertPDF = React.useCallback(async () => {
        const convertPage = async (page: any, canvasName: string) => {
            return new Promise<string>(resolve => {
                let scale = 1.5;
                let viewport = page.getViewport(scale);
                let canvas: any = document.getElementById(canvasName);
                if (canvas) {
                    let context = canvas.getContext('2d');
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;
                    let task = page.render({ canvasContext: context, viewport: viewport });
                    task.promise.then(() => {
                        let url = canvas.toDataURL();
                        resolve(url);
                    });
                }
            });
        };
        try {
            const pdfJS = (window as any)['pdfjs-dist/build/pdf'].PDFJS;
            pdfJS.disableWorker = true;
            const pdf = await pdfJS.getDocument(pdfUrl).promise;
            await appendCanvasAfterNumPages(pdf.numPages);
            let imgsToSet: string[] = [];

            for (let i = 0; i < pdf.numPages; i++) {
                const page = await pdf.getPage(i + 1);
                let pageBase64 = await convertPage(page, CANVAS_INITIAL_ID + i);
                if (pageBase64) imgsToSet.push(pageBase64);
            }
            if (imgsToSet.length > 0) setImgs(imgsToSet);
        } catch (e) {}
    }, [pdfUrl, imgs, setImgs]);

    useEffect(() => {
        if (imgs && imgs.length > 0) {
            setLoading(false);
        }
    }, [imgs]);

    useEffect(() => {
        convertPDF();
    }, [pdfUrl]);

    const download = (base64: string, downloadName: string) => {
        const downloadLink = document.createElement('a');
        document.body.appendChild(downloadLink);
        downloadLink.href = base64;
        downloadLink.target = '_self';
        downloadLink.download = downloadName;
        downloadLink.click();
    };

    const downloadBase64File = () => {
        imgs.forEach((ele, index) => download(ele, `${projectInfo.data?.name}${index}.png`));
    };

    return (
        <MenuItem className={prop.className} onClick={prop.onClick}>
            {loading ? <Spinner /> : <div onClick={downloadBase64File}>{t('header_export_button_png')}</div>}
        </MenuItem>
    );
};

export const CanvasForExportImgs = () => <div id={WRAPPER_DIV_NAME} style={{ height: '100%', width: '100%', position: 'relative', zIndex: '-2' }}></div>;
